import { handleDom } from './handleDom.js';
import { handleScope } from './handleScope.js';
/**
 * An event handler to react to breadcrumbs.
 */

function breadcrumbHandler(type, handlerData) {
  if (type === 'scope') {
    return handleScope(handlerData);
  }

  return handleDom(handlerData);
}

export { breadcrumbHandler };